<template>
  <b-modal id="bulkWithdraw" centered hide-footer
  @hidden="closeModal">
    <div class="d-flex">
      <div class="warning-wrap withdraw-warning">
        <i class="fa fa-triangle-exclamation" />
      </div>
      <div>
        <h6 class="">Withdraw this Enrollment?</h6>
        <p class="light-txt">
          You're about to withdraw the selected {{ isIndividualEnrollment ? 'individual enrollment' : 'group enrollment' }}. 
          Once withdrawn, the {{ isIndividualEnrollment ? 'individual enrollment' : 'group enrollment' }} will be removed from the pending list and this action can't be undone.
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-end flex-column-reverse flex-sm-row mt-3 gap-2">
      <b-button variant="secondary" @click="closeModal">Close</b-button>
      <b-button variant="danger" class="univ-btn m-0 px-5 univ-withdraw" @click="submitBulkWithdraw"
        >{{ isIndividualEnrollment ? 'Withdraw Individual Enrollment' : 'Withdraw Group Enrollment' }}</b-button
      >
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "BulkWithdraw",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isIndividualEnrollment: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$bvModal.show('bulkWithdraw');
      } else {
        this.$bvModal.hide('bulkWithdraw');
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.$bvModal.hide('bulkWithdraw');
    },
    submitBulkWithdraw() {
      this.$emit('submit');
    },
  },
};
</script>
<style>
.univ-withdraw{
    width: fit-content;
}
.warning-wrap{
    background: rgb(242, 242, 217);
      border-radius: 50px;
  height: fit-content;
  padding: 0.7rem 0.8rem;
  margin-right: 1rem;
}
.withdraw-warning {
  background: rgb(242, 217, 217);
}
.withdraw-warning i {
  color: #dc3545;
}
.warning-wrap i {
  color: #dc8d07;
  font-size: 18px;
}
@media (max-width:576px) {
  .univ-withdraw{
    width: 100%;
    max-width: none;
  }
}
</style>
